module.exports = __webpack_public_path__ + "img/park-en-mobile.a86415bd.jpg";